module.exports = __webpack_public_path__ + "img/LogoGranter-03-dark.4cfd89cb.png";